import { useEffect } from 'react';

export const useInitializeTracking = () =>
  useEffect(() => {
    if (import.meta.env.REACT_APP_SEGMENT_KEY)
      window.analytics.load(import.meta.env.REACT_APP_SEGMENT_KEY);
  }, []);
